export const emptyContact = { firstName: '', lastName: '', middleName: '', phone: '', email: '', organization: '', title: '', website: '' };
export type Contact = typeof emptyContact;
const escapeText = (text: string) => text.trim().replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');

// Fold at 75 UTF-8 bytes without splitting a Unicode character (vCard 3.0).
export function foldLine(line: string): string {
    let result = '', bytes = 0;
    Array.from(line).forEach(char => {
        const length = encodeURIComponent(char).replace(/%[A-F\d]{2}/gi, 'x').length;
        if (bytes + length > 75) { result += '\r\n '; bytes = 1; }
        result += char;
        bytes += length;
    });
    return result;
}
export function contactToVCard(contact: Contact): string {
    const name = [contact.firstName.trim(), (contact.middleName || '').trim(), contact.lastName.trim()].filter(Boolean).join(' ');
    if (!name) return '';
    const lines = ['BEGIN:VCARD', 'VERSION:3.0', `N:${escapeText(contact.lastName)};${escapeText(contact.firstName)};${escapeText(contact.middleName || '')};;`, `FN:${escapeText(name)}`];
    const fields = { phone: 'TEL;TYPE=CELL', email: 'EMAIL;TYPE=INTERNET', organization: 'ORG', title: 'TITLE', website: 'URL' };
    Object.entries(fields).forEach(([key, property]) => {
        if (contact[key].trim()) lines.push(`${property}:${escapeText(contact[key])}`);
    });
    return [...lines, 'END:VCARD'].map(foldLine).join('\r\n') + '\r\n';
}
